<template>
    <tr class="matrix__other-answer">
        <td :colspan="span">
            <div class="matrix__other-flex">
                <label :for="'other_' + uuid" v-html="label"></label>
                <input type="text" :id="'other_' + uuid" :value="othervalue" class="form-control form__other-input" @change.stop="$parent.changeOther" maxlength="255" :placeholder="instructions" :tabindex="questionIndex" :readonly="$parent.readOnly" :disabled="$parent.disabled">
            </div>
        </td>
    </tr>
</template>

<script>

export default {
    name: 'matrix-other',

    props: {
        uuid: Number,
        span: Number,
        othervalue: String,
        label: String,
        instructions: String,
        questionIndex: Number,
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-other.vue